import * as React from "react";
import { extendFormGroupProps } from "./use-form-group";
export function Input(props) {
    var internalRef = React.useRef();
    React.useEffect(() => {
        if (props.controlRef) {
            props.controlRef.current = internalRef.current;
        }
    }, []);
    React.useEffect(() => {
        var _a, _b;
        if (props.customValidity) {
            (_a = internalRef.current) === null || _a === void 0 ? void 0 : _a.setCustomValidity(props.customValidity);
        }
        else {
            (_b = internalRef.current) === null || _b === void 0 ? void 0 : _b.setCustomValidity("");
        }
    }, [props.customValidity]);
    props = extendFormGroupProps(props);
    let value = props.value;
    let onChange = props.onChange;
    var type = props.type || "text";
    // var placeholder = props.placeholder || "";
    switch (type) {
        case "text":
        case "number":
        case "date":
            return React.createElement("input", { type: type, name: props.name, placeholder: props.placeholder, required: props.required, min: props.min, readOnly: props.readOnly, disabled: props.disabled, autoFocus: props.autoFocus, className: props.className, style: props.style, value: value != undefined ? value : "", onChange: onChange, ref: internalRef });
        case "textarea":
            return React.createElement("textarea", { name: props.name, placeholder: props.placeholder, required: props.required, readOnly: props.readOnly, disabled: props.disabled, autoFocus: props.autoFocus, className: props.className, style: props.style, value: value != undefined ? value : "", onChange: onChange, ref: internalRef });
        case "select":
            return React.createElement("select", { name: props.name, value: value != undefined ? value : "", onChange: onChange, disabled: props.disabled, autoFocus: props.autoFocus, className: props.className, style: props.style, ref: internalRef },
                props.placeholder &&
                    React.createElement("option", { disabled: props.required, value: "" }, props.placeholder)
            //: <option disabled={props.required} value=""></option>
            ,
                props.children);
        case "checkbox":
            return React.createElement("input", { type: type, name: props.name, checked: value || false, onChange: onChange, readOnly: props.readOnly, disabled: props.disabled, autoFocus: props.autoFocus, className: props.className, style: props.style, ref: internalRef });
        case "radio":
            return React.createElement(React.Fragment, null, props.children.map((e, idx) => React.createElement("div", { key: idx },
                React.createElement("label", { className: "form-input-radio-label" },
                    React.createElement("input", { type: "radio", name: props.name, checked: value === e.value, onChange: onChange, value: e.value, readOnly: props.readOnly, disabled: props.disabled, autoFocus: props.autoFocus, className: props.className, style: props.style }),
                    " \u00A0",
                    e.text))));
        case "hidden":
            return null;
        default: return undefined;
    }
}
//# sourceMappingURL=Input.js.map